import { render, staticRenderFns } from "./autotextarea.vue?vue&type=template&id=62f1c589&scoped=true&"
import script from "./autotextarea.vue?vue&type=script&lang=js&"
export * from "./autotextarea.vue?vue&type=script&lang=js&"
import style0 from "./autotextarea.vue?vue&type=style&index=0&id=62f1c589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f1c589",
  null
  
)

export default component.exports